module.exports = __webpack_public_path__ + "static/media/some-html-and-css-interview-questions.aed6c660.jpg";